import React from 'react'
import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row } from "antd";
import "./QueueToolbar.css";

const QueueToolbar = ({
  keyword,
  onChangeKeyword,
  onClickAddQueue,
  passedCount = 0,
  onClickPassed,
}) => {

  return (
    <Row gutter={[16, 16]}>
      <Col xs={{ span: 24 }} lg={{ span: 14 }}>
        <Button danger size="large" onClick={onClickPassed}>
          Terlewat ({passedCount})
        </Button>
      </Col>
      <Col xs={{ span: 24 }} lg={{ span: 10 }}>
        <div className="queue-right-toolbar-wrapper">
          <Button
            type="primary"
            size="large"
            onClick={onClickAddQueue}
            icon={<PlusOutlined />}
          >
            Tambah Antrian
          </Button>
          <Input
            placeholder="Cari data"
            value={keyword}
            onChange={(e) => onChangeKeyword(e.target.value)}
          />
        </div>
      </Col>
    </Row>
  );
};

export default QueueToolbar;
